

















import { Component, Vue } from 'vue-property-decorator';
@Component({
})
export default class NotFound extends Vue {
  private textoE = '';
  private textoE2 = '';
  
  private created() {
    if (this.$route.path === '/unauthorized') {
      this.textoE = '403 No autorizado';
      this.textoE2 = 'autorizada.';
    } else {
      this.textoE = '404 No localizado';
      this.textoE2 = 'encontrada.';
    }
  }

  private async regresar() {
    window.location.href= 'https://www.petco.com.mx/';
  }

}
